export default "__VITE_ASSET__E4z11r0X__"